import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import { bailAgentService } from '../../../services/bailAgentService';

const LiveStatusIndicator = () => {
  const [currentAgent, setCurrentAgent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCurrentAgent = async () => {
      try {
        const { data, error } = await bailAgentService?.getCurrentAgent();
        
        if (!error && data) {
          setCurrentAgent(data);
        } else {
          // Use general office number as fallback
          setCurrentAgent({
            phone: '(916) 833-0052'
          });
        }
      } catch (error) {
        console.error('Error fetching current agent for status bar:', error);
        // Fallback to general number on error
        setCurrentAgent({
          phone: '(916) 833-0052'
        });
      } finally {
        setLoading(false);
      }
    };

    fetchCurrentAgent();
    
    // Set up real-time updates for agent changes - checks every 30 seconds for shift changes
    const interval = setInterval(fetchCurrentAgent, 30000);
    
    return () => clearInterval(interval);
  }, []);

  // Format phone number display
  const getDisplayPhone = () => {
    if (loading) return '(916) 833-0052';
    return currentAgent?.phone || '(916) 833-0052';
  };

  return (
    <div className="animate-emergency-police text-white py-3 px-4 shadow-md">
      <div className="max-w-4xl mx-auto flex items-center justify-center space-x-3">
        <div className="flex items-center space-x-2">
          {/* Emergency police light animated dot */}
          <div className="w-3 h-3 rounded-full animate-police-light-dot"></div>
          <span className="font-semibold text-sm">Emergency Bail Service Active</span>
        </div>
        
        <div className="h-4 w-px bg-white/30" />
        
        <div className="flex items-center space-x-2">
          {/* Second police light dot */}
          <div className="w-3 h-3 rounded-full animate-police-light-dot" style={{animationDelay: '0.4s'}}></div>
          <span className="font-semibold text-sm">LIVE</span>
        </div>
        
        <div className="h-4 w-px bg-white/30" />
        
        <div className="flex items-center space-x-2">
          <Icon name="Clock" size={16} color="white" />
          <span className="text-sm font-medium">24/7 Bail Agent Available</span>
        </div>
        
        <div className="h-4 w-px bg-white/30" />
        
        <div className="flex items-center space-x-2">
          <Icon name="Phone" size={16} color="white" />
          {/* Dynamic phone number that updates when agents change shifts */}
          <span className="text-sm font-medium">{getDisplayPhone()}</span>
          {loading && (
            <div className="w-2 h-2 bg-white/60 rounded-full animate-pulse ml-1"></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LiveStatusIndicator;